export default {
  accountIdentity: 'Account identity',
  account: 'GGMOMOMO account',
  signedIn: 'Signed in',
  notSignedIn: 'Not signed in',
  signOut: 'Sign out of GGMOMOMO account',
  walletStatus: 'Wallet status',
  walletInfo: 'Wallet information',
  worldAppWallet: 'World App wallet',
  metaMaskConnection: 'MetaMask connection',
  worldChainConnected: 'World Chain · Connected',
  noAddress: 'Address unavailable',
  disconnecting: 'Disconnecting…',
  disconnectMetaMask: 'Disconnect MetaMask',
  language: 'Language',
  languageDescription: 'Choose the language used throughout Bubble Wallet.',
  legal: 'LEGAL',
  legalDocuments: 'Legal documents',
  privacyPolicy: 'Privacy Policy',
  termsOfUse: 'Terms of Use',
} as const;
